import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useUnmount } from 'react-use'
import { AuthContainer, Box, LoginForm, LoginSms } from '../../components'
import { useStore } from '../../stores'
import { LoginProcessStatus } from '../../stores/Login.store'

const Login = observer((): JSX.Element => {
  const { t } = useTranslation()
  const { loginStore } = useStore()

  useUnmount(() => {
    if (!loginStore.isAuthenticated) loginStore.reset()
  })

  const step: { [key: number]: JSX.Element } = {
    [LoginProcessStatus.LOGIN]: <LoginForm />,
    [LoginProcessStatus.SMS]: <LoginSms />,
  }

  return (
    <AuthContainer data-cy="auth-container">
      <Box data-cy="login-page-container">
        <Box
          mb={20}
          display="flex"
          alignItems="center"
          justifyContent="center"
          color="var1"
          data-cy="login-page-title">
          {t('authorization')}
        </Box>
        <div data-cy="login-step-container">
          {step[loginStore.processStatus]}
        </div>
      </Box>
    </AuthContainer>
  )
})

export default Login
